window.Launchpad.jsInlineLoadList.forEach((x) => {
	x();
});